import { LoadingButton } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import RenderContent from '../../components/RenderContent';

function InstructionScreen({ content, handleStart = () => {} }) {
    return (
        <Box
            sx={{
                textAlign: 'left',
                padding: 0,
                paddingTop: 3,
            }}
        >
            <RenderContent htmlString={content} applyListFontSizeClass={true}></RenderContent>

            <Box display={'flex'} justifyContent={'left'} sx={{ mt: '2rem', pb:'1rem' }}>
                <LoadingButton
                    loading={''}
                    variant="contained"
                    color="primary"
                    onClick={handleStart}
                    sx={(theme) => ({
                        marginRight: '0',
                        [theme.breakpoints.down('sm')]: {
                            width: '100%',
                            marginBottom: '0',
                        },
                    })}
                >
                    Start
                </LoadingButton>
            </Box>
        </Box>
    );
}

export default InstructionScreen;
